module.exports = __webpack_public_path__ + "img/version_img1.48f84cb4.png";